/**
 * 메이커 공통 레이아웃 — Clipflow v3.6
 *
 * AI 메이커는 `/ai` 단일 진입으로 통합되며, `/shortform`만 별도 라우트로 유지.
 * 기존 `/longform`, `/youtube-highlight`는 점진 폐기 (Phase 7).
 * 따라서 maker 전용 sub-nav 제거 — V36TopNav가 글로벌 진입을 담당.
 */
'use client'

import V36TopNav from '@/components/layout/V36TopNav'
import { usePathname } from 'next/navigation'

export default function MakersLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname() ?? ''
  // [projectId] 상세 페이지에서는 TopNav 숨김 (워크스페이스 풀스크린)
  const isDetailPage = /\/[a-f0-9-]{36}/.test(pathname)

  return (
    <>
      {!isDetailPage && <V36TopNav />}
      <main style={{ minHeight: '100vh' }}>{children}</main>
    </>
  )
}
